export default __webpack_public_path__ + "static/media/orderbook_navicon.79888b88.svg";